// getShortsIds.js
'use strict';
import {
  INSERT_CLIP_AFTER_X_SHORTS,
  INSERT_CLIP_EVERY_X_SHORTS,
} from '../RemoteConfigKeys.js';

import createCachedSelector from '../resource/createCachedSelector.js';

import getListData from '../selector/getListData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import { getReturnType } from '../action/fetchFeeds.js';

const defaultArray = [];

/**
 * Select shorts ids by shorts category
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} shortsCategory - shorts category.
 * @param {string} livestreamClipCategory - livestream clip category.
 * @return {array} The selected shorts ids.
 */
const getShortsIds = createCachedSelector(
  (state, shortsCategory) =>
    getListData(state, ['shorts', shortsCategory], 'itemIds'),
  (state, shortsCategory, livestreamClipCategory) =>
    getListData(
      state,
      [
        'home',
        getReturnType({ feedName: livestreamClipCategory }),
        livestreamClipCategory,
      ],
      'itemIds'
    ),
  state => getRemoteConfigData(state, INSERT_CLIP_AFTER_X_SHORTS),
  state => getRemoteConfigData(state, INSERT_CLIP_EVERY_X_SHORTS),
  (
    shortsIds = defaultArray,
    livestreamClipIds = defaultArray,
    afterXthShorts = 0,
    everyXthShorts = 0
  ) => {
    if (!livestreamClipIds.length) {
      return shortsIds;
    }
    const result = [];
    let clipIndex = 0;
    shortsIds.forEach((item, index) => {
      const realClipIndex = clipIndex % livestreamClipIds.length;
      switch (true) {
        case afterXthShorts === 0 && index === 0: {
          result.push(livestreamClipIds[realClipIndex]);
          clipIndex += 1;
          result.push(item);
          break;
        }
        case clipIndex === 0 && index + 1 === afterXthShorts: {
          result.push(item);
          result.push(livestreamClipIds[realClipIndex]);
          clipIndex += 1;
          break;
        }
        case index >= afterXthShorts &&
          (index + 1 - afterXthShorts) % everyXthShorts === 0: {
          result.push(item);
          result.push(livestreamClipIds[realClipIndex]);
          clipIndex += 1;
          break;
        }
        default: {
          result.push(item);
          break;
        }
      }
    });
    return result;
  }
)(
  (state, shortsCategory, livestreamClipCategory) =>
    `${shortsCategory}:${livestreamClipCategory}`
);

export default getShortsIds;
